module.exports = __webpack_public_path__ + "static/media/read.4b25c641.mp4";